var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c(
        "b-card",
        [
          _c("FormPrivacyLgpd", {
            ref: "FormPrivacyLgpd",
            attrs: { id: _vm.id, "request-form": _vm.requestForm }
          }),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.saveHandling($event)
                        }
                      }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "m-0" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "6" } },
                            [
                              _c("validation-provider", {
                                staticClass: "flex-grow",
                                attrs: {
                                  name: _vm.$t("status"),
                                  rules: "required",
                                  slim: ""
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(validationContext) {
                                      return [
                                        _c(
                                          "b-form-group",
                                          {
                                            attrs: {
                                              label: _vm.$t("status"),
                                              "label-for": "status"
                                            }
                                          },
                                          [
                                            _c("b-form-select", {
                                              staticClass: "required-select",
                                              attrs: {
                                                id: "status",
                                                options: _vm.listStatus,
                                                "text-field": "label",
                                                "value-field": "key"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "first",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "b-form-select-option",
                                                          {
                                                            attrs: {
                                                              value: null,
                                                              disabled: ""
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              "-- Selecione uma opção --"
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value: _vm.modelStatus,
                                                callback: function($$v) {
                                                  _vm.modelStatus = $$v
                                                },
                                                expression: "modelStatus"
                                              }
                                            }),
                                            _c(
                                              "b-form-invalid-feedback",
                                              {
                                                class: [
                                                  { absolute: _vm.inline }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      validationContext
                                                        .errors[0]
                                                    ) +
                                                    " "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "m-0" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("form_handling_preview"),
                                    "label-for": "pacess"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: { id: "pacess", name: "pacess" },
                                      model: {
                                        value: _vm.publicAccess,
                                        callback: function($$v) {
                                          _vm.publicAccess = $$v
                                        },
                                        expression: "publicAccess"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        { attrs: { value: false } },
                                        [_vm._v(_vm._s(_vm.$t("private")))]
                                      ),
                                      _c(
                                        "b-form-radio",
                                        { attrs: { value: true } },
                                        [_vm._v(_vm._s(_vm.$t("public")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("form_handling"),
                                    "label-for": "treatment"
                                  }
                                },
                                [
                                  _c("simple-editor", {
                                    staticClass: "mb-2",
                                    model: {
                                      value: _vm.textTreatment,
                                      callback: function($$v) {
                                        _vm.textTreatment = $$v
                                      },
                                      expression: "textTreatment"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "m-0 pt-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "forwarding_description_public"
                                    ),
                                    "label-for": "forwarding_description"
                                  }
                                },
                                [
                                  _c("simple-editor", {
                                    staticClass: "mb-2",
                                    model: {
                                      value: _vm.forwardingDescription,
                                      callback: function($$v) {
                                        _vm.forwardingDescription = $$v
                                      },
                                      expression: "forwardingDescription"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-row",
                        { staticClass: "m-0 pt-2" },
                        [
                          _c(
                            "b-col",
                            { attrs: { lg: "12" } },
                            [
                              _c("FormulateInput", {
                                attrs: {
                                  type: "file",
                                  name: "file",
                                  label: "Anexos",
                                  help:
                                    "Selecione um ou mais arquivos em PDF, Word ou imagens",
                                  validation:
                                    "mime:application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,image/jpeg,image/png",
                                  accept: ".pdf,.doc,.docx,.jpg,.jpeg,.png",
                                  multiple: ""
                                },
                                model: {
                                  value: _vm.listFiles,
                                  callback: function($$v) {
                                    _vm.listFiles = $$v
                                  },
                                  expression: "listFiles"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.handlingFiles.length > 0
                        ? _c(
                            "b-row",
                            { staticClass: "pt-2" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c("media-list", {
                                    attrs: {
                                      medias: _vm.handlingFiles,
                                      "show-delete": true,
                                      "action-on-click": false
                                    },
                                    on: { deleteMedia: _vm.deleteMedia }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "mt-1 mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "flex justify-end" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mt-1 mr-1 float-right",
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.validateForm
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.saveHandling()
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                            ),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mt-1 mr-1 float-right",
                                attrs: { variant: "outline-secondary" },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push("/privacy-form")
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }